<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Ticket History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">My Orders</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <!-- <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
                    class="fa fa-filter"></i>Filter</a> -->
                <h3 class="card-title">My Orders</h3>
                <div class="card-tools">
                  <!-- <button class="btn btn-info" @click="exportFile()">
                      <i class="fas fa-download"></i> Export
                    </button> -->
                </div>
              </div>
              <form @submit.prevent="getUsers" method="GET" novalidate>
                <div class="card-body" v-if="showFilter">
                  <div class="form-row">
                    <div class="col-md-6">
                      <!-- Date range -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="created_at">Date range</label>
                        <div class="col-md-9">
                          <date-picker type="datetime" input-class="form-control" v-model="filter.created_at" range
                            lang="en" format="YYYY-MM-DD hh:mm:ss" confirm id="created_at"
                            value-type="YYYY-MM-DD hh:mm:ss"></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-9 offset-md-3">
                          <button type="submit" class="btn btn-common m-2px">
                            <i class="fas fa-search"></i> Search
                          </button>
                          <button type="reset" class="btn btn-warning" @click="resetFilter()">
                            <i class="fas fa-undo"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table common-table">
                    <thead>
                      <!-- Vendor	Subscriber	Order Reference No	Fullfilment Request No	Access CASR	Order State	Activated On	Remarks	Notes	Action -->
                      <tr>
                        <th class="">ID</th>
                        <th class="">Service/Product</th>
                        <th class="">Order Date</th>
                        <th class="">Order No</th>
                        <th class="">Tracking Number</th>
                        <th class="">Status</th>
                        <th class="text-left">Remarks</th>
                        <!-- <th class="text-right">Action</th> -->
                      </tr>
                    </thead>
                    <tbody class="users-list">
                      <tr v-for="(val, index) in list.data" :key="val.id"
                        v-if="val.service_type != 'add_ons' && val.service_charge != 0">
                        <td>
                          {{ index + 1 }}
                        </td>
                        <!-- service_name -->
                        <td>
                          {{ val.service_name }}
                        </td>
                        <td>
                          {{ customFormatter(val.created_at) }}
                        </td>

                        <td>
                          {{
                            !_.isEmpty(val.order_number) ? val.order_number : ""
                          }}
                        </td>
                        <td class="text-left" v-if="val.service_type == 'product'">
                          <a target="_blank" v-if="!_.isEmpty(val.fr_number)"
                            :href="`https://www.ups.com/track?loc=en_GB&tracknum=${val.fr_number}&requester=WT/trackdetails`">
                            {{ val.fr_number }}
                          </a>
                        </td>
                        <td class="text-left" v-else>
                          {{ "N/A" }}
                        </td>

                        <td class="text-left">{{ val.order_state }}</td>
                        <td class="text-left">
                          <span class="order-remarks">{{ val.remarks }}</span>
                        </td>
                        <!-- <td class="text-right"></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="p-4" v-if="_.isEmpty(list.data) && !list.is_loading">
                  <div class="alert alert-default-warning" role="alert">
                    No Order found!
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getList()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
.closed,
.pending,
.open,
.in-progress {
  border-radius: 100px;
  text-align: center;
  padding: 4px 10px 4px;
  display: inline-block;
  font-size: 13px;
}

span.closed {
  color: #16a085;
  background-color: #e1f9f4;
  border-color: #e1f9f4;
}

span.pending {
  color: #f1711d;
  background-color: #ffe9dd;
  border-color: #ffe9dd;
}

span.open {
  color: #2980b9;
  background-color: #e4f4ff;
  border-color: #e4f4ff;
}

span.in-progress {
  color: #efb548;
  background-color: #fbeacb;
  border-color: #fbeacb;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI, SelfcareAPI } from "@/services/api";

const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "MyOrders",
  metaInfo: {
    title: "MyOrders",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }

      // window.$(document).find('.push-menu-class').trigger('click');
    }

    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    // this.api_url = "/ticketList";
    this.getList();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getList();
    });
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `Billing History | ${this.companyName}`
        : "Billing History",
    };
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },

    getList() {
      let _this = this;
      _this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      query.cuid = subscriber ? subscriber.id : null;

      SelfcareAPI.getMyOrders(query)
        .then((response) => {
          _this.list.is_loading = false;
          _this.list = response;
        })
        .catch((error) => { })
        .finally(() => {
          _this.list.is_loading = false;
        });
    },

    apiUsage(query = null) { },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getList();
    },
  },
};
</script>
